/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Alert } from 'sarsaparilla';

export function AdditionalChallengeRequiredAlert({ className }: { className?: string }) {
    return (
        <Alert
            type="warning"
            className={className}
            heading="Additional Verification Required"
            shouldFocusOnMount
        >
            We weren’t able to verify that you’re human just yet. Please complete the
            reCAPTCHA challenge below and try again.
        </Alert>
    );
}

export function RecaptchaFailedAlert({ className }: { className?: string }) {
    return (
        <Alert
            type="error"
            className={className}
            heading="Recaptcha Failed"
            shouldFocusOnMount
        >
            <p>
                We couldn’t confirm that this request came from a real person. We’re sorry
                for the hassle — this is to keep {process.env.SITE_NAME} safe from bots.
                You can try the steps below to resolve the issue.
            </p>
            <ul>
                <li>Switch browsers or devices</li>
                <li>Temporarily disable any VPN or proxy</li>
                <li>Disable ad blockers or privacy browser extensions</li>
                <li>
                    Check your device’s clock/timezone — incorrect system time can
                    occasionally cause problems
                </li>
                <li>
                    Try a different network (switch between Wi-Fi and mobile data) — some
                    networks trigger stricter checks.
                </li>
            </ul>
        </Alert>
    );
}
